import { render, staticRenderFns } from "./_inputRowFooterFlag.vue?vue&type=template&id=32562994&scoped=true"
import script from "./_inputRowFooterFlag.vue?vue&type=script&lang=js"
export * from "./_inputRowFooterFlag.vue?vue&type=script&lang=js"
import style0 from "./_inputRowFooterFlag.vue?vue&type=style&index=0&id=32562994&prod&scoped=true&lang=css"
import style1 from "./_inputRowFooterFlag.vue?vue&type=style&index=1&id=32562994&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32562994",
  null
  
)

export default component.exports